import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import AppButton from '../AppButton';
import { ICONS } from '../../icons';
import appLogo from '../../assets/png/appLogo.png';

export default function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { loginWithTwitch, currentUser } = useAuth();
  const { t } = useTranslation();

  // Load terms acceptance state from localStorage on component mount
  useEffect(() => {
    const savedTermsAcceptance = localStorage.getItem('streamquest_terms_accepted');
    if (savedTermsAcceptance === 'true') {
      setTermsAccepted(true);
    }
  }, []);

  // Save terms acceptance state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('streamquest_terms_accepted', termsAccepted.toString());
  }, [termsAccepted]);

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleTwitchLogin = async () => {
    if (!termsAccepted) {
      setError(t('loginPage.mustAcceptTerms'));
      return;
    }

    try {
      setError('');
      setLoading(true);
      loginWithTwitch();
    } catch (error) {
      setError(t('loginPage.failedToLogin') + ': ' + error.message);
      setLoading(false);
    }
  };

  const handleTermsChange = (e) => {
    setTermsAccepted(e.target.checked);
    // Clear error when user checks terms
    if (e.target.checked && error === t('loginPage.mustAcceptTerms')) {
      setError('');
    }
  };

  return (
    <div className="container">
      <div className="auth-form">
        <div className="auth-logo-container">
          <img src={appLogo} alt="StreamQuest Logo" className="auth-logo" />
        </div>
        
        <div className="auth-welcome">
          <h1>{t('loginPage.welcome')}</h1>
          <p>{t('loginPage.twitchLogin')}</p>
        </div>
        
        {error && <div className="error">{error}</div>}
        
        <div className="terms-section">
          <label className="terms-checkbox">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={handleTermsChange}
            />
            <span className="checkmark"></span>
            <span className="terms-text">
              {t('loginPage.acceptTerms.text')}{' '}
              <a 
                href="https://streamquest.io/terms-and-conditions" 
                target="_blank" 
                rel="noopener noreferrer"
                className="terms-link"
              >
                {t('loginPage.acceptTerms.termsLink')}
              </a>
              {' '}{t('loginPage.acceptTerms.and')}{' '}
              <a 
                href="https://streamquest.io/privacy-policy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="terms-link"
              >
                {t('loginPage.acceptTerms.privacyLink')}
              </a>
            </span>
          </label>
        </div>
        
        <div className="twitch-auth-section">
          <AppButton
            onClick={handleTwitchLogin}
            disabled={loading || !termsAccepted}
            loading={loading}
            className="twitch-login-btn"
            icon={ICONS.TWITCH}
          >
            {loading ? t('loginPage.connectingToTwitch') : t('loginPage.loginWithTwitch')}
          </AppButton>
        </div>
        
        <div className="auth-info">
          <p>{t('loginPage.twitchInfo')}</p>
        </div>
      </div>
    </div>
  );
} 